<template>
    <div class="mainWeb">
    <el-dialog title="阈值设置"  :visible.sync="showyuzhi" width="1000px">
      <div style="margin-bottom:20px;">卡名称：{{yuzhiObj.courseName}}</div>
      <el-form :model="formparamsYuzhi" :rules="rules" ref="formparamsYuzhi" label-width="140px">
        <el-form-item label="过期提前提醒天数" prop="cardExpireWarn" v-if="iscourseDays">
          <el-input class="w220" v-model.number="formparamsYuzhi.cardExpireWarn" placeholder="请输入过期天数最小阈值"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetFormYuzhi('formparamsYuzhi')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="submitFormYuzhi('formparamsYuzhi')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="卡信息"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
            <el-form-item label="微信价格" prop="weChatPrice">
            <el-input class="w220" v-model="formparams.weChatPrice" placeholder="请输入票卡的价格"></el-input>
            </el-form-item>
            <el-form-item label="卡说明" prop="description">
            <el-input type="textarea" rows="4" v-model="formparams.description" placeholder="请输入卡说明"></el-input>
            </el-form-item>
            <el-form-item  label="出售最大数量" prop="maxSell">
              <el-input-number v-model.number="formparams.maxSell" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item  label="购买最大数量">
              <el-input class="w220" v-model="formparams.canBuyNum" placeholder="请输入购买最大数量"></el-input>
            </el-form-item>
            <el-form-item label="是否支持购买" prop="limit" label-width="140px">
                <!-- isPurchase  0 否  1是 -->
              <el-switch
                v-model="formparams.canntBuy"
                active-value= '0'
                inactive-value= '1'
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
            <el-form-item  label="展示顺序">
              <el-input class="w220" v-model="formparams.showSort" placeholder="请输入展示顺序"></el-input>
            </el-form-item>
            <el-form-item label="分店" prop="shopNum">
              <el-select v-model="formparams.shopNum" placeholder="请选择">
                  <el-option
                  v-for="item in this.cardshopList"
                  :key="item.shopNum"
                  :label="item.name"
                  :value="item.shopNum"
                  ></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="卡信息"  :visible.sync="dialogVisible2" width="1000px">
      <el-form :model="formparamsAddImg" ref="formparamsAddImg" label-width="100px">
        <el-form-item label="上传卡图" required ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            *提示*：为了更好的用户体验，图片请提供620*310像素，文件大小不超过500kb。
          </el-form-item>
          <el-form-item label="是否支持充值" prop="limit" label-width="140px">
            <!-- isPurchase  0 否  1是 -->
            <el-switch
              v-model="formparamsAddImg.ifCanRecharge"
              active-value= '1'
              inactive-value= '0'
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
          <el-form-item label="每天可消费次数" prop="cardConsumNum" label-width="110px">
            <el-input class="w220" v-model="formparamsAddImg.cardConsumNum" placeholder="请输入每天可消费次数"></el-input>
          </el-form-item>
          <el-form-item label="每周可消费次数" prop="conTimeOneWeek" label-width="110px">
            <el-input class="w220" v-model="formparamsAddImg.conTimeOneWeek" placeholder="请输入每周可消费次数"></el-input>
          </el-form-item>
          <el-form-item label="每月可消费次数" prop="conTimeOneMonth" label-width="110px">
            <el-input class="w220" v-model="formparamsAddImg.conTimeOneMonth" placeholder="请输入每月可消费次数"></el-input>
          </el-form-item>
          <el-form-item label="会员卡优惠" label-width="110px" v-show="infC.length > 0">
            <div style="margin-bottom:10px;" v-for="item of infC" :key="item.id">
              <el-input class="w220" :value="item.carditemname" disabled></el-input>
              <span style="margin-left:10px;">折扣：</span><el-input class="w220" :value="'折扣价格'+item.cardcut" disabled v-if="item.cardpercenttype=='折后价格'"></el-input>
              <el-input class="w220" :value="item.cardcut+'折'" disabled v-if="item.cardpercenttype=='折'"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="使用优惠的支付方式" label-width="140px">
            <el-radio-group v-model="formparamsAddImg.offerPayType">
              <el-radio :label="0">仅本卡支付</el-radio>
              <el-radio :label="1">仅会员卡支付</el-radio>
              <el-radio :label="2">仅微信支付</el-radio>
              <el-radio :label="3">本卡和微信支付</el-radio>
              <el-radio :label="4">全部卡和微信支付</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetForm2('formparamsAddImg')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="addForm('formparamsAddImg')">确 定</el-button>
      </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table :data="tableDataOff" height="68vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="name" label="卡名称"></el-table-column>
        <!-- <el-table-column prop="shortname" label="名称简写"></el-table-column>   -->
        <el-table-column prop="cardtype" label="卡类型"></el-table-column>
        <el-table-column scope="scope" label="卡图片">
          <template slot-scope="scope">
            <img class="imgList" style="width:100px;height:50px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.imgpath" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="cardprice" label="购卡金额"></el-table-column>
        <!-- <el-table-column prop="cardconsumnum" label="每天可消费次数"></el-table-column>
        <el-table-column prop="conTimeOneWeek" label="每周可消费次数"></el-table-column>
        <el-table-column prop="conTimeOneMonth" label="每月可消费次数"></el-table-column> -->
        
        <el-table-column width="350" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">修改图片</el-button>
            <el-button style="width:100px"  type="primary" @click="setThreshold(scope.row)">阈值设置</el-button>
             <el-button style="width:100px"  type="success" v-show="scope.row.state!=1" @click="addOnlineCard(scope.row)">上线</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getInfCs, getTbShopsByCs, cardAvailable, insertCardsSell, getShops, getCardShopList,getThreshold,setThreshold} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  name:"onLine",
  props:["tableDataOff","shopNumChild","name"],
  watch: {
    // shopNum:(newVal,oldVal)=>{
    //   this.params.shopNum = newVal; 
    //   this.getTableList()
    //   // alert(this.params.shopNum)
    // }
  },
  data() {
    return {
      loading: true,
      dialogVisible: false,
      showyuzhi: false,
      dialogVisible2:false,
      hideUpload:false,
      yuzhiObj: {
        courseName: '',
      },
      iscourseDays: false, //是否有过期时间
      date:[],//开始时间结束时间
      infC: [],
      rules:{
        cardExpireWarn: [
          { required: true, message: '请输入阈值', trigger: 'blur' },
        ],
        weChatPrice: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern:/^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/, message: '请输入正确金额格式', trigger: 'blur' }
        ],
        shopNum:[
          { required: true, message:'请选择分店', trigger:'change' }
        ],
        description:[{ required:true,message:'请输入票说明',trigger:'blur' }],
        maxSell:[
          { required: true, message: '出售最大数量不能为空'},
          { type: 'number', message: '必选为数字'}
        ]
      },
      weekS:[
        {label:'星期一',value:1},
        {label:'星期二',value:2},
        {label:'星期三',value:3},
        {label:'星期四',value:4},
        {label:'星期五',value:5},
        {label:'星期六',value:6},
        {label:'星期日',value:7},
      ],
      formparams:{
        cardName:'',
        cardShortName:'',
        weChatPrice:'',
        description:'',
        shopNum:'',
        maxSell:'',
        canBuyNum: '',
        canntBuy: '0',
        showSort: null
      },
      formparamsYuzhi: {
        cardExpireWarn: '',
        shortName: '',
        shopNum: ''
      },
      formData:{},
      formparamsAddImg:{
        ifCanRecharge: '0',
        cardConsumNum: null,
        conTimeOneWeek: null,
        conTimeOneMonth: null,
        offerPayType: 0
      },
      timeList:[],
      fileList:[],
      //票列表
      // tableDataOff:[],
      //票类型
      options:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      cardshopList:[],
      total: 0,
      currentPage: 1,
      params: {
        name:null,
        shopNum:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
  },
  mounted() {
  },
  methods: {
    // 查询卡可使用的分店
     getCardShopList(cardShortName) {
      getCardShopList({cardShortName}).then((res)=>{
        this.cardshopList = res.data
        console.log(res)
      })
    },
    getTableList(){
      this.params.shopNum = this.shopNumChild
      this.params.name = this.name
      getInfCs(this.params).then((res)=>{  
        if(res.msg=='success'){
          // this.tableDataOff = res.data.info
          this.$emit('getTableDataOff',res.data)
        }else {
          this.$message.error(res.data)
        }
        this.loading= false
      })
    },
    //查询分店类型
    getShopsList(row){
      getTbShopsByCs({cardShortName:row}).then((res)=>{
        this.shopList = res.data
      })
    },
    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    setThreshold(row) {
      if(row.enddate!=0) {
        this.iscourseDays = true
        this.formparamsYuzhi.cardExpireWarn = null
      }else {
        this.iscourseDays = false
      }
      this.yuzhiObj.courseName = row.name
      this.formparamsYuzhi.shortName = row.shortname
      this.getThreshold(row.shopNum,row.shortname,'4')
      this.showyuzhi = true
    },
     // 查看项目阈值
    getThreshold(shopNum,shortName,type) {
      this.formparamsYuzhi.shopNum = shopNum
      getThreshold({shopNum:shopNum,shortName:shortName,type:type}).then(res=>{
        if(res.msg == 'success'){
          if(res.data.cardExpireWarn) {
            this.formparamsYuzhi.cardExpireWarn = res.data.cardExpireWarn
          }
        }else{
          this.$message.error(res.data)
        }
      })
    },
    edit(row){
      console.log(row)
      this.infC = row.infC
      if(this.fileList){
        this.hideUpload = true
      } else {
        this.hideUpload = false
      }
      this.fileList=[]
      this.dialogVisible2 = true
      this.formparamsAddImg.id = row.id
      if(row.cardconsumnum&&row.cardconsumnum!=0) {
        this.formparamsAddImg.cardConsumNum = row.cardconsumnum
      }else {
        this.formparamsAddImg.cardConsumNum = ''
      }
      if(row.conTimeOneWeek&&row.conTimeOneWeek!=0) {
        this.formparamsAddImg.conTimeOneWeek = row.conTimeOneWeek
      }else {
        this.formparamsAddImg.conTimeOneWeek = ''
      }
      if(row.conTimeOneMonth&&row.conTimeOneMonth!=0) {
        this.formparamsAddImg.conTimeOneMonth = row.conTimeOneMonth
      }else {
        this.formparamsAddImg.conTimeOneMonth = ''
      }
      if(row.ifCanRecharge&&row.ifCanRecharge=='1') {
        this.formparamsAddImg.ifCanRecharge = row.ifCanRecharge
      }else {
        this.formparamsAddImg.ifCanRecharge = '0'
      }
      if(row.offerPayType) {
        this.formparamsAddImg.offerPayType = row.offerPayType
      }else {
        this.formparamsAddImg.offerPayType = 0
      }
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.imgpath})
    },
    //修改图片
   async addForm(){
      this.formData = new FormData()
      this.$refs.upload.submit();
      if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('上传卡的图片不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
              this.$message.error('上传图片大小不能超过500kb');
              this.fileList= []
              this.hideUpload= false
              return
          }
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数组字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
      this.formData.append('id', this.formparamsAddImg.id);
      this.formData.append('cardConsumNum', this.formparamsAddImg.cardConsumNum);
      this.formData.append('conTimeOneWeek', this.formparamsAddImg.conTimeOneWeek);
      this.formData.append('conTimeOneMonth', this.formparamsAddImg.conTimeOneMonth);
      this.formData.append('ifCanRecharge', this.formparamsAddImg.ifCanRecharge);
      this.formData.append('offerPayType', this.formparamsAddImg.offerPayType);
      let config = {
          headers: {
            'Content-Type':'multipart/form-data',
            'token':sessionStorage.getItem('token')
          }
      }
      console.log(this.formData)
      const {data: res} = await this.$http.post('card/updateInfCsImgPath', this.formData, config)
      if(res.msg == 'success'){
        this.dialogVisible2 = false
        this.$message({
          type:'success',
          message:'添加成功'
        })
        this.getTableList()
      } else{
        this.dialogVisible = true
        this.$message.error(res.data);
      }
    },
    addOnlineCard(row){
      this.getCardShopList(row.shortname)
      this.formparams.shopNum = ''
      this.dialogVisible= true
      this.formparams.weChatPrice=''
      this.formparams.maxSell = ''
      this.formparams.canBuyNum = '' //可购买次数
      this.formparams.cardName = row.name
      this.formparams.cardShortName = row.shortname
      this.formparams.description = row.remarks
      // this.formparams.shopNum = row.shopNum
      this.getShopsList(row.shortname)
    },
    // 上线接口
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          cardAvailable({cardShortName:this.formparams.cardShortName,shopNum:this.formparams.shopNum}).then((res)=>{
            if(res.msg == 'success'){
              insertCardsSell(this.formparams).then((res)=>{
                if(res.msg == 'success'){
                  this.getTableList()
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'上线成功'
                  })
                } else{
                  this.dialogVisible = true
                  this.$message.error(res.data);
                }
              })
              this.getTableList()
            } else{
              // this.dialogVisible = true
              this.$message.error(res.data);
            }
          })
        }
      });
    },
    submitFormYuzhi(formparamsYuzhi) {
      this.$refs[formparamsYuzhi].validate(valid => {
        if (valid) {
          setThreshold({cardExpireWarn:this.formparamsYuzhi.cardExpireWarn,shortName:this.formparamsYuzhi.shortName,shopNum:this.formparamsYuzhi.shopNum,type:4}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'设置成功'
              })
              this.formparamsYuzhi.cardExpireWarn = ''
              this.resetFormYuzhi(this.formparamsYuzhi)
            }else{
              this.$message.error(res.data)
            }
          })
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //取消
    resetFormYuzhi(formparamsYuzhi) {
      this.showyuzhi = false;
      this.formparamsYuzhi.cardExpireWarn = ''
      if(this.$refs[formparamsYuzhi]!=undefined){
        this.$refs[formparamsYuzhi].clearValidate();
      }
    },
    resetForm2(formparamsAddImg) {
      this.dialogVisible2 = false;
      this.$refs[formparamsAddImg].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
  }
};
</script>
<style scoped lang="scss">
.tableList {
  width: 100%;
  margin-top: 20px;
  /* height: 73vh; */
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// offlineCard.vue?33a37f38